import {differenceInCalendarDays} from "date-fns";
import {toZonedTime} from "date-fns-tz";

export type VisitStatus = "recent" | "moderate" | "old";

const TZ_JST = "Asia/Tokyo";

/**
 * 最終来店日から来店ステータスを計算する（JST 日数ベース）
 * - recent: 90日以内（≈3ヶ月）
 * - moderate: 91〜180日（≈6ヶ月）
 * - old: 181日以上 or 来店なし
 */
export function calculateVisitStatus(lastVisitDate: string | null): VisitStatus {
  if (!lastVisitDate) return "old";

  const parsed = new Date(lastVisitDate);
  if (Number.isNaN(parsed.getTime())) return "old";

  const now = toZonedTime(new Date(), TZ_JST);
  const lastVisit = toZonedTime(parsed, TZ_JST);
  const diffDays = differenceInCalendarDays(now, lastVisit);

  if (diffDays <= 90) return "recent";
  if (diffDays <= 180) return "moderate";
  return "old";
}
